export default "__VITE_ASSET__tjmybH8F__"